import React from 'react';
import c from 'classnames';
import s from './SimpleTooltipText.scss';

interface Props {
  className?: string;
}

const SimpleTooltipText: React.FC<React.PropsWithChildren<Props>> = ({ children, className }) => {
  return <span className={c(s['root'], className)}>{children}</span>;
};
SimpleTooltipText.displayName = 'SimpleTooltipText';

export default SimpleTooltipText;
